import * as actionTypes from './../actions/weightAdjustmentAction';

const initialState = {
  selected: null,
  data: false,
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT:
      return {
        ...state,
        selected: action.selected,
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        selected: initialState.selected,
        ready: true,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
